//Comentario necesario para codificación en UTF-8, ver Inc6743
'use strict';

(function () {
	var App = angular.module('pphhApp');
	App.service('admDir3Service', ['$http', function ($http) {
		this.getConnections = function(fechaDesde, fechaHasta) {
			var request = {
					method: "GET",
					url: _contextPath + "/admdir3/syncInfo"
				};
			return $http(request);
		}
	
		this.propagarCambios = function( ) {
			var request = {
					method: "POST",
					url: _contextPath + "/admdir3/sync"
				};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}
	}]);
})();
